import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { queryClient } from "./lib/queryClient.js";
import { router } from "./router.js";
import { AdminAuthProvider } from "./auth/AdminAuthProvider.js";
import { installChineseZodErrorMap } from "./lib/zodErrorMap.js";
import "./styles.css";

installChineseZodErrorMap();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("根节点 #root 不存在");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AdminAuthProvider>
        <RouterProvider router={router} />
      </AdminAuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
